import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="command-palette"
// Global command palette triggered by Cmd+K / Ctrl+K
export default class extends Controller {
  static targets = [
    "dialog",
    "input",
    "results",
    "palette",
    "defaultState",
    "typeMoreState",
    "loadingState",
  ];

  connect() {
    this.boundHandleKeydown = this.handleKeydown.bind(this);
    document.addEventListener("keydown", this.boundHandleKeydown);
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundHandleKeydown);
  }

  handleKeydown(event) {
    // Cmd+K (Mac) or Ctrl+K (Windows/Linux)
    if ((event.metaKey || event.ctrlKey) && event.key === "k") {
      event.preventDefault();
      this.open();
    }
  }

  open() {
    this.dialogTarget.showModal();
    this.inputTarget.focus();
    this.inputTarget.select();
  }

  close() {
    this.dialogTarget.close();
    this.inputTarget.value = "";
    this.showDefaultState();
    if (this.hasPaletteTarget) {
      this.paletteTarget.reset();
    }
  }

  search() {
    clearTimeout(this.searchTimeout);
    const query = this.inputTarget.value.trim();

    if (query.length === 0) {
      this.showDefaultState();
      return;
    }

    if (query.length === 1) {
      this.showTypeMoreState();
      return;
    }

    // Show loading state immediately
    this.showLoadingState();

    // Debounce the actual fetch
    this.searchTimeout = setTimeout(() => {
      this.fetchResults(query);
    }, 200);
  }

  fetchResults(query) {
    fetch(`/content/search?q=${encodeURIComponent(query)}`, {
      headers: {
        Accept: "text/vnd.turbo-stream.html",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
          ?.content,
      },
    })
      .then((response) => response.text())
      .then((html) => {
        this.hideAllStates();
        Turbo.renderStreamMessage(html);
      });
  }

  showDefaultState() {
    this.hideAllStates();
    this.clearResultGroups();
    if (this.hasDefaultStateTarget) {
      this.defaultStateTarget.classList.remove("hidden");
    }
  }

  showTypeMoreState() {
    this.hideAllStates();
    this.clearResultGroups();
    if (this.hasTypeMoreStateTarget) {
      this.typeMoreStateTarget.classList.remove("hidden");
    }
  }

  showLoadingState() {
    this.hideAllStates();
    this.clearResultGroups();
    if (this.hasLoadingStateTarget) {
      this.loadingStateTarget.classList.remove("hidden");
    }
  }

  hideAllStates() {
    if (this.hasDefaultStateTarget) {
      this.defaultStateTarget.classList.add("hidden");
    }
    if (this.hasTypeMoreStateTarget) {
      this.typeMoreStateTarget.classList.add("hidden");
    }
    if (this.hasLoadingStateTarget) {
      this.loadingStateTarget.classList.add("hidden");
    }
  }

  clearResultGroups() {
    if (this.hasResultsTarget) {
      this.resultsTarget
        .querySelectorAll("el-command-group")
        .forEach((group) => group.remove());
      // Also remove any "no results" message that was injected
      const noResults = this.resultsTarget.querySelector(
        ".command-palette-no-results"
      );
      if (noResults) noResults.remove();
    }
  }

  // Called when a result link is clicked
  selectResult(event) {
    // Close the dialog after a brief delay to allow navigation
    setTimeout(() => this.close(), 100);
  }
}
